import { render, staticRenderFns } from "./MediakitProductSettings.vue?vue&type=template&id=70ede24a&"
import script from "./MediakitProductSettings.vue?vue&type=script&lang=js&"
export * from "./MediakitProductSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports